import { IRootState } from 'src/store/rootReducer';
import { Store } from 'redux';
import setupAxiosAuthInterceptors from 'src/store/config/axios-interceptor';

export default function appRun(store: Store<IRootState, any>) {
  setupAxiosAuthInterceptors();
}
